import { ControlledTable } from "Components";
import { columnType } from "DataTypes/Table";

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.DeviceTypeCol("33%"),
  ControlledTable.ColumnData.DeviceNameCol("33%"),
  ControlledTable.ColumnData.DeviceSupplierNameCol("33%"),
];
